// extracted by mini-css-extract-plugin
export default {"base":"ResponsiveBlock_base__7VntJ","isPadded":"ResponsiveBlock_isPadded__zmBhD"};